import React, {useState} from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import fancybox from "component/Fancybox/Fancybox";
import { popinfo } from "component/Fancybox/Fancybox";
import { useFormik } from 'formik';
import api from "api";

const ComponentConfigTaglineForm = connect(stateMap) (props => {
    const formik = useFormik({
        initialValues: {
            UserShortBio    : props.profile.UserShortBio
        }
        ,onSubmit : (values) => {
            let savingTagline = popinfo('loading', 'Updating Tagline', 'Thank your for completing your information')

            api('/Config/Tagline', 'post', values , 'Bearer ' + props.auth.token)
                .then(function(response){

                    savingTagline.close();

                    if(props.onChanged)
                    {
                        props.onChanged.apply(null, [values.UserShortBio]);
                    }

                })
                .catch(error => {
                    popinfo('error', 'Updating Tagline', error, {}, savingTagline)
                })
        }
    });

    return (
        <form className="generic-form" onSubmit={formik.handleSubmit}>
            <div className="form-group">
                <label htmlFor="" className="label">Enter in 100 characters, the tagline makes yourself recognizable quickly</label>
                <textarea className="form-control textarea" name="UserShortBio" onChange={formik.handleChange} value={formik.values.UserShortBio} rows="3"></textarea>
            </div>
            <div className="form-group text-right">
                <input type="submit" className="btn btn-primary btn-small" value="Update" />
            </div>
        </form>
    )
})

const ComponentConfigTagline = connect(stateMap) (props => {   
    const [profile, setProfile] = useState(null);

    useEffect(() => {

        setProfile(props.profile);

    }, [props.profile])
    
    const openDialog = () => {
        if(!profile)
        {
            return;
        }

        const TaglinePop = fancybox(
            <div className="w-640">
                <ComponentConfigTaglineForm profile={profile} onChanged={(tagline) => {
                    TaglinePop.close();

                    if(props.onChanged)
                    {
                        props.onChanged.apply(null, [tagline]);
                    }

                }}/>
            </div>
        )
    }

    return (
        profile && <button onClick={openDialog} className="bold color-orange">[Edit Tagline]</button>
    )
});

export { ComponentConfigTagline }